import { GET_LOADING } from "../actionTypes";

export const SetLoading = (isLoading) => {
  return async (dispatch) => {
    dispatch({ type: GET_LOADING, payload: isLoading });
  };
};
